<template>
  <el-card class="app-table-container" :body-style="{ padding: '20px' }">
    <div slot="header">
      <div class="global-table-header">
        <div></div>
        <!-- <list-search ref="listSearch" @listSearchEvn="listSearchEvn" /> -->
        <button class="global-button-style" @click="addHandle">
          新建
        </button>
      </div>
    </div>
    <div class="global-body-wrap">
      <TableView
        :tableData="tableData"
        :tableProp="tableProp"
        handleWidth="200"
        :handleBtn="handleBtn"
        @tableHandle="tableHandle"
      />
    </div>
    <Pagination :pageSize="params.pageSize" :total="total" @pageNum="pageNum" />
    <AddComponent
      v-if="addPopup"
      :title="title"
      :ruleForm="ruleForm"
      :ruleProps="ruleProps"
      :rules="rules"
      @addEvn="formFeedback"
    />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
import ListSearch from '@/components/listSearch'
import AddComponent from '@/components/addPopup'

export default {
  components: {
    TableView,
    ListSearch,
    Pagination,
    AddComponent
  },
  computed: {
    ...mapGetters(['addPopup']),
    ruleProps() {
      let ruleProps = [
        {
          prop: 'key',
          label: 'KEY'
        },
        {
          prop: 'desc',
          label: '条件'
        }
      ]
      return ruleProps
    },
    rules() {
      let rules = {
        key: [{ required: true, message: '内容不能为空', trigger: 'blur' }],
        desc: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      }
      return rules
    },
    tableProp() {
      let tableProp = [
        {
          prop: 'key',
          label: 'KEY'
        },
        {
          prop: 'desc',
          label: '条件'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' }
      ]
    }
  },
  data() {
    return {
      title: '',
      ruleForm: {
        key: '',
        desc: ''
      },
      currentItem: null,
      actionType: 'add',
      tableData: [],
      total: 0,
      params: { pageSize: 20, page: 1 }
    }
  },
  methods: {
    async getList() {
      let res = await this.$http.gptGptConditionList(this.params)
      this.tableData = res.data.rows
      this.total = res.data.rowCount
    },

    tableHandle({ type, data }) {
      this.currentItem = data
      switch (type) {
        case 'edit':
          this.editHandle()
          break
        case 'del':
          this.delHandle()
          break
        default:
          break
      }
    },
    addHandle() {
      this.ruleForm = {
        key: '',
        desc: ''
      }
      this.title = '新增'
      this.actionType = 'add'
      this.$store.commit('windowHandle', 'addPopup')
    },
    editHandle() {
      this.ruleForm = {
        key: this.currentItem.key,
        desc: this.currentItem.desc
      }
      this.title = '编辑'
      this.actionType = 'edit'
      this.$store.commit('windowHandle', 'addPopup')
    },
    async delHandle() {
      try {
        await this.$confirm(null, this.$t('alertMsg.delConfirm'), {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          showClose: false,
          center: true
        })
        await this.$http.delGptCondition({ ids: [this.currentItem.id] })
        this.getList()
      } catch (error) {}
    },
    formFeedback(form) {
      if (this.actionType === 'add') {
        this.create(form)
      } else {
        this.edit(form)
      }
    },

    async create(form) {
      await this.$http.addGptCondition(form)
      this.$store.commit('windowHandle')
      this.getList()
    },

    async edit(form) {
      console.log(this.currentItem)
      await this.$http.updateGptCondition(this.currentItem.id, form)
      this.$store.commit('windowHandle')
      this.getList()
    },
    listSearchEvn() {},
    pageNum(page) {
      this.params.page = page
      this.getList()
    }
  },
  mounted() {
    this.getList()
  }
}
</script>
